import React, { useReducer } from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import {
  SystemModal,
  SystemModalHeader,
  SystemModalIcon,
  SystemModalContent,
  Heading,
  Body,
  InformationIcon,
  Box,
  CrossLightIcon,
} from '@edreamsodigeo/prisma-design-system';
import { withLoadPlaceholder } from '@/HOC/withDatamesh';

const DatameshTrackLoad = withLoadPlaceholder('unavailable:load');

function NotAvailableModal({ onClick }) {
  const { t } = useTranslation();
  const [open, toggleOpen] = useReducer((state) => !state, true);

  return (
    <SystemModal
      open={open}
      onClose={() => {
        toggleOpen();
        onClick();
      }}
    >
      <DatameshTrackLoad />
      <SystemModalHeader type="informative">
        <Box
          data-testid="not_available_close"
          onClick={() => {
            toggleOpen();
            onClick();
          }}
          sx={{
            position: 'absolute',
            right: '26px',
            top: '20px',
            fontWeight: 400,
          }}
        >
          <CrossLightIcon color="neutral.80" data-testid="close_icon" />
        </Box>
        <SystemModalIcon>
          <InformationIcon color="primary.50" />
        </SystemModalIcon>
      </SystemModalHeader>
      <SystemModalContent>
        <Box sx={{ textAlign: 'center' }}>
          <Heading type="2" weight="medium" color="neutral.90">
            {t('pricefreeze.modal.resultPage.title')}
          </Heading>
          <Box mt="base">
            <Body type="base" weight="regular" color="neutral.80">
              {t('pricefreeze.modal.resultPage.body')}
            </Body>
          </Box>
        </Box>
      </SystemModalContent>
    </SystemModal>
  );
}

export function NotAvailableDialog(props) {
  return <NotAvailableModal {...props} />;
}
